import React from "react";
import { SendToast } from "@networkraildigitalfactory/components";
import { Redirect, Route } from "react-router-dom";
import cloudURL from "./cloud";
import { GBR_EMAIL } from "../constants/email.constants";

const redirect = () => {
  const auth = JSON.parse(localStorage.getItem("authenticated"));
  if (!auth) {
    SendToast("Your session has expired. Please log in.", "error");
  }
  return (
    <Redirect
      to={{
        pathname: auth ? "/" : "/login",
      }}
    />
  );
};

export const AuthenticatedRoute = ({ component: Component, authenticated, ...rest }) => (
  <Route {...rest} render={() => (authenticated ? <Component {...rest} /> : redirect())} />
);

export const LMRoute = ({
  component: Component,
  authenticated,
  isLineManager,
  isUserProfileValid,
  isAdmin,
  ...rest
}) => (
  <Route
    {...rest}
    render={() =>
      authenticated && isLineManager && isUserProfileValid && !isAdmin ? (
        <Component {...rest} />
      ) : (
        redirect()
      )
    }
  />
);

export const ValidProfileRoute = ({
  component: Component,
  authenticated,
  isUserProfileValid,
  isAdmin,
  ...rest
}) => (
  <Route
    {...rest}
    render={() =>
      authenticated && isUserProfileValid && !isAdmin ? <Component {...rest} /> : redirect()
    }
  />
);

export const Regexes = {
  email: /^\S+@\S+$/,
  numeric: /^[0-9]*$/,
  postcode: /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/,
};

export function formatBytes(a, b) {
  if (a === 0) return "0 Bytes";
  const c = 1024;
  const d = b || 2;
  const e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const f = Math.floor(Math.log(a) / Math.log(c));
  return `${parseFloat((a / c ** f).toFixed(d))} ${e[f]}`;
}

export const removeKey = (obj, deleteKey) => {
  const clone = Object.assign({}, obj);
  delete clone[deleteKey];
  return clone;
};

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export const getBuild = () => {
  let build = {};
  const cloud = cloudURL();
  if (cloud.includes("prod-v4.4w70")) {
    build = { env: "PROD", webUrl: "https://iperform.nrdigital.co" };
  } else if (cloud.includes("dev.apps.nwr-dev-v4")) {
    build = {
      env: "DEV",
      webUrl: "https://iperform-web-app-dev.apps.nwr-dev-v4.sqw5.p1.openshiftapps.com",
    };
  } else if (cloud.includes("ppte.apps.nwr-dev-v4")) {
    build = {
      env: "PPTE",
      webUrl: "https://iperform-web-app-ppte.apps.nwr-dev-v4.sqw5.p1.openshiftapps.com",
    };
  } else if (cloud.includes("test.9069")) {
    build = {
      env: "TEST",
      webUrl: "https://iperform-web-app-test.9069.nwr-dev.openshiftapps.com",
    };
  } else {
    build = { env: "LOCAL", webUrl: "http://localhost:3000" };
  }
  return build;
};

export const toTop = () => {
  document.scrollTop = 0;
  document.body.scrollTop = 0;
  document.scrollingElement.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  window.scroll(0, 0);
};

export const a11yGrowTextarea = (event, id) => {
  if (event.key === "ArrowDown" || event.key === "ArrowUp") {
    let newHeight;
    const textarea = document.getElementById(id);
    if (event.key === "ArrowDown") {
      newHeight = textarea.scrollHeight + 10;
    } else if (event.key === "ArrowUp") {
      newHeight = textarea.scrollHeight - 10;
    }
    textarea.style.cssText = `height:${newHeight}px;`;
  }
};

export const getEmployeeEmailByPathname = (path, page) => {
  const email = path
    .split("/my-team/")
    .pop()
    .split(page)[0];
  return email;
};

export const getCurrentFinancialYear = () => {
  let fiscalyear;
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  if (currentMonth <= 3 || (currentMonth === 4 && today.getDate() < 6)) {
    const currYrTwoDigit = `${today.getFullYear()}`.toString().substring(2, 4);
    fiscalyear = `${today.getFullYear() - 1}/${currYrTwoDigit}`;
  } else {
    const nextYrTwoDigit = `${today.getFullYear() + 1}`.toString().substring(2, 4);
    fiscalyear = `${today.getFullYear()}/${nextYrTwoDigit}`;
  }
  return fiscalyear;
};

export const getCurrentFinancialYearSingle = () => {
  let fiscalyear;
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  if (currentMonth <= 3 || (currentMonth === 4 && today.getDate() < 6)) {
    fiscalyear = `${today.getFullYear() - 1}`;
  } else {
    fiscalyear = `${today.getFullYear()}`;
  }
  return fiscalyear;
};

export const capitalise = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const preventFormDefault = (e) => {
  if (e.key === "Enter") e.preventDefault();
};

export const auditHistoryTextReplacer = (objectiveData, fieldStr, newTextStr) => {
  if (objectiveData?.auditHistory.length) {
    const objectiveDataauditHistoryModified = objectiveData?.auditHistory.map((audit) => {
      if (audit.user.includes(GBR_EMAIL)) {
        audit.text = audit.text.replaceAll(fieldStr, newTextStr);
      }
      return audit;
    });

    objectiveData.auditHistory = objectiveDataauditHistoryModified;
  }
  return objectiveData;
};
